module.exports = __webpack_public_path__ + "img/Boot.c6d2ea73.svg";